/**
 * Converts a given file type to a "friendly" format for readability and/or tracking purposes.
 * Copied from E1
 * E.g. it converts 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' to 'XLSX'.
 *
 * @param {string} fileType - The file type to be converted.
 * @returns {string} A friendly representation of the file type, for easier identification.
 */
export const convertToFriendlyFormat = (fileType: string) => {
  let friendlyFileType = fileType; // Make a temporary variable for a "friendly" file name for mixpanel

  if (!fileType) {
    friendlyFileType = 'Unknown';
  } else if (fileType === 'text/csv' || fileType === 'application/vnd.ms-excel') {
    friendlyFileType = 'CSV';
  } else if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    friendlyFileType = 'XLSX';
  }

  return friendlyFileType;
};
